import { useState } from 'react'
import { Button } from 'components/Button'
import { CreditCard } from 'lucide-react'
import List from 'components/SavedPaymentMethods/List'

const SavedPaymentMethods = ({ onClick }) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleSelect = (method: any) => {
    onClick(method)
  }

  return (
    <div className="w-full">
      <Button
        type="button"
        onClick={() => setIsOpen(true)}
        variant="tertiary"
        className="w-full font-medium rounded-lg py-2.5"
        icon={<CreditCard size={20} />}
        title="Saved Payment Method"
      />

      <List
        open={isOpen}
        onClose={() => setIsOpen(false)}
        onSelect={handleSelect}
      />
    </div>
  )
}

export default SavedPaymentMethods
